import { TEDParseNumberMode } from '../FormatterTypes';
import { formatterStrParamDef } from '../Utils/ParamUtils';

// Util functions that didn't fit anywhere else

// Checks if a string, containing only 1 char is a digit
export function isDigit(c: string): boolean {
  if (c.length > 1 || c.length === 0) {
    return false;
  }

  return Number.isInteger(parseInt(c, 10));
}

export function nextQuotedString(str: string): string {
  const regExp = /"([^"]*)"/;
  const result = regExp.exec(str);
  if (!result) {
    return '';
  }

  return result[1];
}

/**
 * Inserts a string into another string, beginning at 'index'
 */
export function insertIntoString(
  insert: string,
  into: string,
  index: number
): string {
  return into.slice(0, index) + insert + into.slice(index);
}

/**
 * Takes an array of charcodes, and returns a string with these characters in it
 *
 * @param charCodes array of numbers, that will be taken for character codes
 * @param index at what index in charCodes to start looking
 * @param count how many charcodes you want to read in charCodes
 */
export function stringOfCharCodes(
  charCodes: number[],
  index: number,
  count: number
): string {
  return charCodes
    .slice(index, index + count)
    .map(c => String.fromCharCode(c))
    .join('');
}

// returns a string with 'count' number of c's in a row
export function stringOfChars(c: string, count: number): string {
  let result = '';
  for (let i = count - 1; i >= 0; i--) {
    result += c;
  }

  return result;
}

// Clamps a number between lowerLimit and upperLimit
export function iLimit(
  value: number,
  lowerLimit: number,
  upperLimit: number
): number {
  if (value > upperLimit || lowerLimit > upperLimit) {
    return upperLimit;
  } else if (value < lowerLimit) {
    return lowerLimit;
  } else {
    return value;
  }
}

// Used in displayers
export function numberMultiple(
  mode: TEDParseNumberMode,
  params: string,
  defaultParams: string
): number {
  if (mode !== TEDParseNumberMode.pnmPercent) {
    let base = formatterStrParamDef('Base', params, defaultParams, '1');
    switch (base) {
      case 'P':
        return 100;
      case 'K':
      case 'T':
        return 0.001;
      case 'M':
        return 0.000001;
      default:
        if (base === '1000') {
          return 0.001;
        } else if (base === '1000000') {
          return 0.000001;
        } else {
          return 1;
        }
    }
  } else {
    return 100;
  }
}

export function nextFormatItem(
  p: string,
  index: number
): {
  result: boolean;
  format: string;
  formatText: string;
  count: number;
  nextIndex: number;
} {
  let result = false;
  let format = '';
  let formatText = '';
  let count = 0;
  let nextIndex = index;

  if (index >= p.length) {
    return { result, format, formatText, count, nextIndex };
  }
  while (index < p.length && p[index] < ' ') {
    index++;
  }
  switch (p[index]) {
    case '0':
      break;
    case '1':
    case '2':
    case '3':
    case '4':
    case '5':
    case '6':
    case '7':
    case '8':
    case '9': {
      let tmpCount = 0;
      while (index < p.length && tmpCount < 100 && isDigit(p[index])) {
        tmpCount = tmpCount * 10 + p.charCodeAt(index) - '0'.charCodeAt(0);
        index++;
      }
      while (
        index < p.length &&
        isDigit(p[index]) &&
        p.charCodeAt(index) <= 32 &&
        p.charCodeAt(index) < 0
      ) {
        index++;
      }

      if (
        tmpCount > 0 &&
        tmpCount < 100 &&
        p[index] !== "'" &&
        p[index] !== '"' &&
        index < p.length
      ) {
        result = true;
        format = p[index];
        count = tmpCount;
        index++;
      }
      break;
    }
    case "'":
    case '"':
      result = true;
      format = "'";
      formatText = nextQuotedString(p.substring(index));
      index += formatText.length + 3; // + 1 for =, + 2 for ""
      count = 1;
      break;
    default:
      result = true;
      format = p[index];
      while (index < p.length && p[index] === format) {
        count++;
        index++;
      }
      break;
  }

  nextIndex = index;
  return { result, format, formatText, count, nextIndex };
}

export const quote = (text: string, quote: string): string => {
  if (!quote) {
    return text;
  }

  return `${quote}${text.replace(quote, `${quote}${quote}`)}${quote}`;
};

export const makeNumberFormatString = (
  sign: boolean,
  intMax: number,
  decMax: number = 0,
  percent: boolean = false,
  forceDecimals: boolean = false,
  degrees: boolean = false
): string => {
  let result = sign ? '-' : '';

  result += `${intMax}u`;
  if (decMax > 0) {
    if (forceDecimals) {
      result += `.${decMax}f`;
    } else {
      result += `|.${decMax}g`;
    }
  }

  if (percent) {
    result += '%';
  }

  if (degrees) {
    result += ''; // ska vara '°', men är inte aktuellt i backend
  }

  return result;
};
